// Cosmetic dice motion is independent of the committed 0.00–99.99 game result.
export const ROLL_DURATION = 1450;
const clamp = value => Math.max(0, Math.min(1, value));
const quarter = () => Math.floor(Math.random() * 4) * 90;
const normalize = angle => ((angle % 360) + 360) % 360;

function bounce(t) {
  if (t < .54) return Math.sin(Math.PI * t / .54) * 29;
  if (t < .76) return Math.sin(Math.PI * (t - .54) / .22) * 10;
  if (t < .90) return Math.sin(Math.PI * (t - .76) / .14) * 3;
  return 0;
}

export function createDiceAnimator(root) {
  const dice = [...root.querySelectorAll('.rolling-die')].map((element, index) => ({
    lift: element.querySelector('.die-lift'),
    cube: element.querySelector('.die-cube'),
    shadow: element.querySelector('.die-shadow'),
    angles: [0, 0, 0],
    from: [0, 0, 0],
    to: [0, 0, 0],
    delay: index * 70,
    duration: 1260 + index * 40,
    direction: index ? 1 : -1,
  }));

  function paint(die, angles, t = 1) {
    const height = bounce(t);
    const drift = Math.sin(Math.PI * t) * 10 * die.direction;
    const wobble = Math.sin(t * Math.PI * 8) * (1 - t) * 5;
    die.lift.style.transform = `translate3d(${drift.toFixed(2)}px, ${(-height).toFixed(2)}px, 0) rotateZ(${wobble.toFixed(2)}deg)`;
    die.cube.style.transform = `rotateX(${angles[0].toFixed(2)}deg) rotateY(${angles[1].toFixed(2)}deg) rotateZ(${angles[2].toFixed(2)}deg)`;
    die.shadow.style.transform = `translateX(${(drift * .8).toFixed(2)}px) scale(${(1 + height * .009).toFixed(3)})`;
    die.shadow.style.opacity = (.35 - height * .006).toFixed(3);
  }

  return {
    start() {
      for (const die of dice) {
        die.from = [...die.angles];
        // Several full turns, then a valid quarter-turn orientation. The two
        // dice travel in opposite directions and land at different times.
        die.to = [0, 1, 2].map(axis => quarter() + 360 * die.direction * (axis === 2 ? 1 : 2 + Math.floor(Math.random() * 2)));
        paint(die, die.from, 0);
      }
    },
    update(elapsed) {
      for (const die of dice) {
        const t = clamp((elapsed - die.delay) / die.duration);
        const spin = 1 - Math.pow(1 - clamp(t / .9), 3);
        const angles = die.from.map((angle, axis) => angle + (die.to[axis] - angle) * spin);
        paint(die, angles, t);
      }
    },
    finish() {
      for (const die of dice) {
        die.angles = die.to.map(normalize);
        paint(die, die.angles);
      }
    },
  };
}
